import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { API_TAB_TYPES, ApiconfigService } from './apiconfig.service';
import { ToastrService } from 'ngx-toastr';
import {
	MonacoEditorConstructionOptions,
	MonacoStandaloneCodeEditor
} from '@materia-ui/ngx-monaco-editor';
import { USERDEFINEDAPI } from './model/apiConfig.model';
import { firstValueFrom } from 'rxjs';
import { APP_BUILDER_PERMISSIONS, PERMISSIONS_ACTIONS } from '../../constants/proj.cnst';


@Component({
  selector: "lib-apiconfig",
  templateUrl: "./apiconfig.component.html",
  styleUrls: ["./apiconfig.component.scss"],
})
export class ApiconfigComponent {
  stage: string = "define";
  apiForm!: FormGroup;
  AuthApiGroup!: FormGroup;
  authApiuserCreds!: FormGroup;
  authApiEmailCreds!: FormGroup;
  authApiKeyCreds!: FormGroup;
  headerkeyValueGroup!: FormGroup;
  paramkeyValueGroup!: FormGroup;

  //for api test 
  varablesTest!:FormGroup;
  updatedUrl!:string;
  updatedBody!:any;
  updatedParams!:any;
  updatedHeaders!:any;

  //
  apiType: string = "authApi";
  apiAddons!: FormGroup;
  apiResponce: any;
  option!: string;
  editApi!: boolean;
  selectedApi!: USERDEFINEDAPI;
  authApis!: any[];
  customApis!: any[];
  apiKeys!:string[];
  apiTabTypes = API_TAB_TYPES;

  editorOptions: MonacoEditorConstructionOptions = {
		theme: 'vs-light',
		language: 'json',
		roundedSelection: true,
		quickSuggestions:false
	};
	editor!: MonacoStandaloneCodeEditor;

  appPermissions = APP_BUILDER_PERMISSIONS;
  permissionsActions = PERMISSIONS_ACTIONS;

  constructor(
    private _fb: FormBuilder,
    private apiConfigService: ApiconfigService,
    private toasterService: ToastrService,
  ) {}

  ngOnInit(): void {
    this.apiForm = this._fb.group({
      name: ["", [Validators.required,Validators.minLength(5),Validators.maxLength(45)]],
      url: ["",[ Validators.required,,Validators.pattern(/^(https?|http):\/\/[^\s$.?#].[^\s]*$/i)]],
      method: ["GET", Validators.required],
      apiheaders: this._fb.array([]),
      body: [""],
      variables: this._fb.array([]),
      authentication: [""],
      queryParameters: this._fb.array([]),
      pathVariables: [""]
    });

    this.AuthApiGroup = this._fb.group({
      name: ["", [Validators.required,Validators.minLength(5),Validators.maxLength(45)]],
      url: ["", [Validators.required,Validators.pattern(/^(https?|http):\/\/[^\s$.?#].[^\s]*$/i)]],
      authType: ["user", Validators.required],
      headers: this._fb.array([]),
      body: [""],
    });

    this.headerkeyValueGroup = this._fb.group({
      key: ["", Validators.required],
      value: ["", Validators.required],
    });

    this.paramkeyValueGroup = this._fb.group({
      key: ["", Validators.required],
      value: ["", Validators.required],
    });

    this.apiTestForms()
    this.preSetters();
    this.serviceSubscriptions();
    this.formValueChanges();
  }
  isValidUrl(url: string): boolean {
    const urlPattern = /^(https?|http):\/\/[^\s$.?#].[^\s]*$/i;
    return urlPattern.test(url);
  }

  preSetters() {
    this.apiConfigService.userApis$.subscribe((data: any) => {
      this.authApis = data.authTypeApis;
      this.customApis = data.apis;
    });
  }

  //#region  for Api Test 
  apiTestForms(){
    this.varablesTest = this._fb.group({
      variableValues: this._fb.array([])
    });
  }

  editorInit(editor: MonacoStandaloneCodeEditor) {
		this.editor = editor
	}

  formValueChanges(){
    this.apiForm.get('authentication')?.valueChanges.subscribe(async (apiId:string) => {
      let selectedAuthApi:USERDEFINEDAPI = this.authApis.find((api:USERDEFINEDAPI) => api.apiId === apiId);
      if(selectedAuthApi){
      let response = await this.apiConfigService.makeDataSourceAuthApiRequest(selectedAuthApi.apiURL,selectedAuthApi.method,selectedAuthApi.requestBody,selectedAuthApi.headers);
      this.fetchKeysFromAPI(response);
      }
    })
  }

  initializeTestApi() {
    this.selectedApi.apiURL ? this.updatedUrl = this.apiConfigService.appendQueryParameters(this.selectedApi.apiURL,this.selectedApi.queryParams) : false;
    // Assuming selectedApi and its variables are fetched from somewhere
    const variables = this.selectedApi?.variables || [];

    // Add form controls for each variable
    if(!this.selectedApi?.isAuthenticatedApi){
      this.variableValues.clear();
      variables.forEach((variable:any) => {
        this.addVariableValue(variable.key,variable.defaultValue);
      });
    }
    
  }

  stageSetter(event:any){
    if(event.value === "test"){
      this.initializeTestApi();
    }
  }

  get variableValues(): FormArray {
    return this.varablesTest.get('variableValues') as FormArray;
  }

  addVariableValue(key:string,defaultValue:any) {
    this.variableValues.push(this._fb.group({
      key: [key],
      value: [''],
      defaultValue:[defaultValue],
      checked:[false] // You can set default value here if needed
    }));
  }

  onChange(event : any, index:number) {
    // Update form value when selection or input changes
    this.variableValues.controls[index].get('value')?.setValue(event.target.value);
    this.updatedUrl =  this.apiConfigService.replacePlaceholders(this.selectedApi.apiURL,this.variableValues.value);
    this.updatedBody = this.apiConfigService.replacePlaceholders(this.selectedApi.requestBody,this.variableValues.value);
    // this.updatedParams = this.apiConfigService.replacePlaceholders(this.selectedApi.queryParams,this.variableValues.value);
    // this.updatedHeaders = this.apiConfigService.replacePlaceholders(this.selectedApi.headers,this.variableValues.value);
  }

  variableChecked(event : any, index:number) {
    // Update form value when selection or input changes
    this.variableValues.controls[index].get('checked')?.setValue(event);
    this.updatedUrl = this.apiConfigService.replacePlaceholders(this.selectedApi.apiURL,this.variableValues.value);
    this.updatedBody = this.apiConfigService.replacePlaceholders(this.selectedApi.requestBody,this.variableValues.value);
  }
  //#endregion

  serviceSubscriptions() {
    this.apiConfigService.selectedApi$.subscribe(async(data: any) => {
      this.apiheaders.clear();
      this.authHeaders.clear();
      this.variables.clear();
      this.queryParameters.clear();
      this.apiResponce = {};
      this.apiForm.reset();
      this.AuthApiGroup.reset();
      if(data.event == 'click'){
      this.stage = 'define';
      }
      if (data.authApi) {
        this.apiType = "authApi";
        this.option = "Body";
      } else {
        this.apiType = "api";
        this.option = "Headers";
      }

      this.selectedApi = data.apiData;
      if (data.apiData != null ) {
        let apidata = data.apiData;
        if (!data.authApi) {
          this.editApi = true;
          let variables = apidata.variables;
          this.apiForm.patchValue({
            name: apidata.apiName,
            url: apidata.apiURL,
            method: apidata.method,
            body: apidata.requestBody,
            authentication: apidata.authenticatedApiId,
          });

          if(apidata.authenticatedApiId){
            let selectedAuthApi:USERDEFINEDAPI = this.authApis.find((api:USERDEFINEDAPI) => api.apiId === apidata.authenticatedApiId);
            if(selectedAuthApi){
            let response = await this.apiConfigService.makeDataSourceAuthApiRequest(selectedAuthApi.apiURL,selectedAuthApi.method,selectedAuthApi.requestBody,selectedAuthApi.headers);
            this.fetchKeysFromAPI(response);
            }
          }
          if (apidata.headers.length > 0) {
            apidata.headers.forEach((obj: any) => {
              this.apiheaders.push(
                this._fb.group({
                  key: [obj.key, Validators.required],
                  value: [obj.value, Validators.required],
                })
              );
            });
          }

          if (apidata.queryParams?.length > 0) {
            apidata.queryParams.forEach((obj: any) => {
              this.queryParameters.push(
                this._fb.group({
                  key: [obj.key, Validators.required],
                  value: [obj.value, Validators.required],
                })
              );
            });
          }

          variables.forEach((obj: any) => {
            this.variables.push(
              this._fb.group({
                key: [obj.key, Validators.required],
                defaultValue: [obj.defaultValue, Validators.required],
                type: [obj.type, Validators.required],
              })
            );
          });
        } else {
          this.editApi = true;
          this.selectedApi = apidata;
          let headers = this.apiConfigService.convertObjectToArray(
            apidata.headers
          );
          this.AuthApiGroup.patchValue({
            name: apidata.apiName,
            url: apidata.apiURL,
            method: apidata.method,
            authType: apidata.authType,
            body:JSON.stringify(apidata.requestBody),
          });
          headers.forEach((obj) => {
            this.authHeaders.push(
              this._fb.group({
                key: [obj.key, Validators.required],
                value: [obj.value, Validators.required],
              })
            );
          });
        }
      } else {
        this.editApi = false;
      }
      // else{

      // }
    // this.initializeTestApi();
    });
  }

  addQueryParameter() {
    this.queryParameters.push(
      this._fb.group({
        key: ["", Validators.required],
        value: ["", Validators.required],
      })
    );
  }

  addAuthHeader() {
    this.authHeaders.push(
      this._fb.group({
        key: ["", Validators.required],
        value: ["", Validators.required],
      })
    );
  }

  addVariables() {
    this.variables.push(
      this._fb.group({
        key: ["", Validators.required],
        defaultValue: ["", Validators.required],
        type: ["", Validators.required],
      })
    );
  }

  get apiheaders() {
    return this.apiForm.get("apiheaders") as FormArray;
  }
  get authHeaders() {
    return this.AuthApiGroup.get("headers") as FormArray;
  }

  removeHeader(index: number): void {
    this.apiheaders.removeAt(index);
  }

  removeAuthHeader(index: number): void {
    this.authHeaders.removeAt(index);
  }

  get queryParameters() {
    return this.apiForm.get("queryParameters") as FormArray;
  }

  removeQueryParameter(index: number): void {
    this.queryParameters.removeAt(index);
  }

  // Method to update a query parameter at a specific index
  updateQueryParameter(index: number, newQueryParameter: any): void {
    const queryParameterGroup = this.queryParameters.at(index) as FormGroup;
    if (queryParameterGroup) {
      queryParameterGroup.patchValue(newQueryParameter);
    }
  }

  get variables() {
    return this.apiForm.get("variables") as FormArray;
  }

  removeVariable(index: number): void {
    this.variables.removeAt(index);
  }

  // Method to update a variable at a specific index
  updateVariable(index: number, newVariable: any): void {
    const variableGroup = this.variables.at(index) as FormGroup;
    if (variableGroup) {
      variableGroup.patchValue(newVariable);
    }
  }

  addApiHeaderParams() {
    this.apiheaders.push(this.addAuthHeaders());
  }

  addAuthHeaders(): FormGroup {
    return this._fb.group({
      key: [],
      value: [],
    });
  }

  deleteHeader(index: number) {
    this.apiheaders.removeAt(index);
  }

 async submit(isAuthApi: boolean) {
    if (this.apiForm.valid || this.AuthApiGroup.valid) {
      let apiResponse :any;
      try {
        if (!this.editApi) {
          apiResponse = await firstValueFrom(this.apiConfigService.addUserApi(
            !isAuthApi ? this.apiForm.value : this.AuthApiGroup.value,
            isAuthApi
          ));
        } else {
          apiResponse = await firstValueFrom(this.apiConfigService.updateUserApi(!isAuthApi ? this.apiForm.value : this.AuthApiGroup.value,isAuthApi,this.selectedApi?.apiId))
        }

        await this.apiConfigService.getAllApisResquest();
        let userApis = this.apiConfigService.getUserApis()
        let api = isAuthApi ? userApis.authTypeApis.find((item: any) => item.apiId == apiResponse.apiId) : userApis.apis.find(
              (item: any) => item.apiId == apiResponse.apiId
            );
        this.apiConfigService.setSelectedApi({
          apiData: api,
          authApi: api.isAuthenticatedApi,
          event: "redirect",
        });

        this.editApi = true;
        this.stage = "test";
        this.option = "Headers";
        
      } catch (error:any) {
        if(error?.status == 403) {
          this.toasterService.error('You do not have permission to access this resource.');
        }else if(error.status === 400){
          this.toasterService.error(error?.error?.message ?? "Something went wrong. Please try again later. ");
        }else{
          this.toasterService.error("Something went wrong. Please try again later.");
        }
      }
      
      console.log(apiResponse);
    } else {
      this.toasterService.error("Please Fill All Required Fields");
    }
  }

  deleteAPI() {
    if (this.selectedApi.apiId != null) {
      this.apiConfigService.deleteUserApi(this.selectedApi.apiId);
      this.editApi = false;
      this.apiForm.reset();
      this.AuthApiGroup.reset();
    }
  }

 async testAPICall() {
    let apiURL = this.updatedUrl ?? this.selectedApi.apiURL;
    let requestBody = this.updatedBody ?? this.selectedApi.requestBody;
    if (this.selectedApi.isAuthenticatedApi) {
      this.apiResponce = await this.apiConfigService.makeDataSourceAuthApiRequest(
        apiURL,
        this.selectedApi.method,
        requestBody,
        this.selectedApi.headers
      );

    } else {
      if(this.selectedApi.authenticatedApiId) {
        let authApi = this.authApis.find((api:any) => api.apiId === this.selectedApi.authenticatedApiId)

        let authResponse:any = await this.apiConfigService.makeDataSourceAuthApiRequest(authApi.apiURL,authApi.method,authApi.requestBody,authApi.headers);
        
     
        let token = this.apiConfigService.getValidTokenFromApi(authResponse);

        if (token) {
          this.selectedApi.headers['Content-Type'] = "application/json; charset=utf-8";
          this.selectedApi.headers['Authorization'] = `Bearer ${token}`;
        } 
      }

      await this.apiConfigService.makeDataSourceApiRequest(
        apiURL,
        this.selectedApi.method,
        requestBody,
        this.selectedApi.headers,
      ).then(data => {
        this.apiResponce = data;
      }).catch(error =>  {
        this.apiResponce = {
          status: error.status,
          name: error.name,
          error: error.error,
        };
      } )
      
    }
    
  }

  async getAuthApiResponce(event:any){
    let authApi = this.authApis.find((item) => item.apiId === event.value);
    let responce = await this.apiConfigService.makeDataSourceAuthApiRequest(authApi.apiURL,authApi.method,authApi.requestBody,authApi.headers)
      this.fetchKeysFromAPI(responce);
  }

  fetchKeysFromAPI(data: any) {
    if (Array.isArray(data)) {
      this.apiKeys = Object.keys(data[0]);
    }
    else if (data) {
      this.apiKeys = Object.keys(data);

    }
  }
}
